import { useState } from 'react';
import { useSnackbar } from 'notistack';
import {
  addProduct,
  cartEdit,
  clearCart,
  downloadCartXlsx,
} from '../../../../crud/cart.crud';
import { API_DOMAIN } from '../../../../constants';
import { checkHash } from '../../../../utils/utils';
import { IGuestCart } from '../interfaces';

interface IDownloadCartXlsxResponse {
  data: {
    link: string;
  };
}

export function useDownloadCartXlsx() {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const openFile = (fileLink: string) => {
    window.open(`${API_DOMAIN}${fileLink}`, '_blank');
  };

  const syncGuestCart = async (guestCart: IGuestCart) => {
    const hash = await checkHash();
    await clearCart(hash);
    await cartEdit(guestCart.fio, guestCart.email, guestCart.phone, hash, guestCart.received_at);

    for (const item of guestCart.items) {
      if (item.priceValue?.vendor) {
        await addProduct({
          product_id: item.product.id!,
          count: item.count,
          hash,
          vendor_id: item.priceValue.vendor.id,
        });
      }
    }

    return hash;
  };

  const downloadByHash = async (hash: string) => {
    const response = await downloadCartXlsx(hash);
    const data = response.data as IDownloadCartXlsxResponse;
    openFile(data.data.link);
  };

  const download = async (hash: string) => {
    setLoading(true);
    try {
      await downloadByHash(hash);
    } catch {
      enqueueSnackbar('Не удалось сформировать файл', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const downloadGuest = async (guestCart: IGuestCart) => {
    setLoading(true);
    try {
      const hash = await syncGuestCart(guestCart);
      await downloadByHash(hash);
    } catch {
      enqueueSnackbar('Не удалось сформировать файл', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return { download, downloadGuest, loading };
}
